"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.initialState = exports.FAILEDTOUPDATE = exports.UPDATED = exports.UPDATING = exports.FAILEDTOCREATE = exports.CREATED = exports.CREATING = exports.FAILED = exports.FETCHED = exports.FETCHING = exports.STANDBY = void 0;
const fp = require("fp-ts");
const monocle = require("monocle-ts");
const ActionTypes = require("../../actionTypes/trmvrmeterentries/remark");
const _folderListReducer = require("../../modules/files/list/reducers");
const imagesFolderTreeReducer = _folderListReducer.default('remark-images');
const confirmationImagesFolderTreeReducer = _folderListReducer.default('remark-confirmation-images');
exports.STANDBY = 'STANDBY';
exports.FETCHING = 'FETCHING';
exports.FETCHED = 'FETCHED';
exports.FAILED = 'FAILED';
exports.CREATING = 'CREATING';
exports.CREATED = 'CREATED';
exports.FAILEDTOCREATE = 'FAILEDTOCREATE';
exports.UPDATING = 'UPDATING';
exports.UPDATED = 'UPDATED';
exports.FAILEDTOUPDATE = 'FAILEDTOUPDATE';
exports.initialState = {
    status: exports.STANDBY,
    remarks: [],
    createdRemarkUuid: undefined,
    currentRemark: undefined,
    currentRemarkImages: imagesFolderTreeReducer.initialState,
    currentRemarkConfirmationImages: confirmationImagesFolderTreeReducer.initialState,
    validation: {
        status: 'NONE'
    }
};
const statusLens = monocle.Lens.fromProp('status');
const remarksLens = monocle.Lens.fromProp('remarks');
const currentRemarkLens = monocle.Lens.fromProp('currentRemark');
const createdRemarkUuidLens = monocle.Lens.fromProp('createdRemarkUuid');
const imagesFolderContentLens = monocle.Lens.fromProp('currentRemarkImages');
const confirmationImagesFolderContentLens = monocle.Lens.fromProp('currentRemarkConfirmationImages');
const validationLens = monocle.Lens.fromProp('validation');
exports.methods = {};
exports.methods[ActionTypes.UPDATE_REMARK_INFO_VALIDATION] = (state, action) => fp.function.compose(statusLens.set('FAILED'), validationLens.set({
    status: 'ERROR',
    errors: action.payload.reduce((rv, x) => {
        ;
        (rv[x.key] = rv[x.key] || []).push(x.value);
        return rv;
    }, {})
}))(state);
exports.methods[ActionTypes.FETCH_REQUEST] = (state, action) => statusLens.set(exports.FETCHING)(state);
exports.methods[ActionTypes.FETCH_SUCCESS] = (state, action) => {
    return fp.function.compose(remarksLens.set(action.payload), statusLens.set(exports.FETCHED))(state);
};
exports.methods[ActionTypes.FETCH_FAILED] = (state, action) => statusLens.set(exports.FAILED)(state);
// All meter's remarks
exports.methods[ActionTypes.FETCH_ALL_REQUEST] = (state, action) => statusLens.set(exports.FETCHING)(state);
exports.methods[ActionTypes.FETCH_ALL_SUCCESS] = (state, action) => {
    return fp.function.compose(remarksLens.set(action.payload), statusLens.set(exports.FETCHED))(state);
};
exports.methods[ActionTypes.FETCH_ALL_FAILED] = (state, action) => statusLens.set(exports.FAILED)(state);
// Create a new Remark
exports.methods[ActionTypes.CREATE_REMARK_REQUEST] = (state, action) => statusLens.set(exports.CREATING)(state);
exports.methods[ActionTypes.CREATE_REMARK_SUCCESS] = (state, action) => fp.function.compose(createdRemarkUuidLens.set(action.payload.uuid), statusLens.set(exports.CREATED), validationLens.set({ status: 'NONE' }), currentRemarkLens.set(action.payload), imagesFolderContentLens.set(imagesFolderTreeReducer.initialState), confirmationImagesFolderContentLens.set(confirmationImagesFolderTreeReducer.initialState), remarksLens.set([action.payload, ...remarksLens.get(state)]))(state);
exports.methods[ActionTypes.CREATE_REMARK_FAILED] = (state, action) => statusLens.set(exports.FAILEDTOCREATE)(state);
// Fetch a single Remark
exports.methods[ActionTypes.FETCH_REMARK_REQUEST] = (state, action) => statusLens.set(exports.FETCHING)(state);
exports.methods[ActionTypes.FETCH_REMARK_SUCCESS] = (state, action) => {
    return fp.function.compose(currentRemarkLens.set(action.remark), statusLens.set(exports.FETCHED))(state);
};
exports.methods[ActionTypes.FETCH_REMARK_FAILED] = (state, action) => statusLens.set(exports.FAILED)(state);
// Update Remark
exports.methods[ActionTypes.UPDATE_REMARK_REQUEST] = (state, action) => statusLens.set(exports.UPDATING)(state);
exports.methods[ActionTypes.UPDATE_REMARK_SUCCESS] = (state, action) => {
    return fp.function.compose(statusLens.set(exports.UPDATED), validationLens.set({ status: 'NONE' }), remarksLens.modify((remarks) => remarks.map((r) => {
        if (r.uuid === action.remark.uuid) {
            return action.remark;
        }
        return r;
    })), currentRemarkLens.set(action.remark))(state);
};
exports.methods[ActionTypes.UPDATE_REMARK_FAILED] = (state, action) => statusLens.set(exports.FAILEDTOUPDATE)(state);
exports.methods[ActionTypes.CLEAR] = (state, action) => (Object.assign({}, exports.initialState));
exports.methods[ActionTypes.CLEAR_CURRENT_REMARK] = (state, action) => {
    return fp.function.compose(currentRemarkLens.set(exports.initialState.currentRemark), validationLens.set({ status: 'NONE' }))(state);
};
const imagesFolderContentMethods = Object.keys(imagesFolderTreeReducer.methods).reduce((prev, curr) => {
    prev[curr] = (state, action) => imagesFolderContentLens.set(imagesFolderTreeReducer.reducer(state.currentRemarkImages, action))(state);
    return prev;
}, {});
const confirmationImagesFolderContentMethods = Object.keys(confirmationImagesFolderTreeReducer.methods).reduce((prev, curr) => {
    prev[curr] = (state, action) => confirmationImagesFolderContentLens.set(confirmationImagesFolderTreeReducer.reducer(state.currentRemarkConfirmationImages, action))(state);
    return prev;
}, {});
exports.methods = Object.assign(exports.methods, imagesFolderContentMethods, confirmationImagesFolderContentMethods);
//# sourceMappingURL=remark.js.map